import React, { useState } from "react";
import ViewGroupDialog from "./ViewGroupDialog";
import VoteDetailsDialog from "./VoteDetailsDialog";

const GroupScoreCard = (props) => {
  const { item, index } = props;
  const [showGroupDialog, setShowGroupDialog] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [selectedVote, setSelectedVote] = useState(null);

  const handleViewDetails = (vote) => {
    setSelectedVote(vote);
    setIsDetailsOpen(true);
  };
  // Close dialog
  const handleCloseDetails = () => {
    setSelectedVote(null);
    setIsDetailsOpen(false);
  };
  return (
    <>
      <tr className="appeal-hovered">
        <td className="text-left">
          <strong> {index} </strong>
        </td>
        <td className="text-left text-truncate">{item.names}</td>
        <td className="text-left text-truncate">{item.groupName}</td>
        <td className="text-left text-truncate">{item.fiscalYearName}</td>
        <td className="text-left text-truncate">{item.positionName}</td>
        <td className="text-left text-truncate">{item.unitName}</td>
        <td className="text-left text-truncate">{item.voterCount}</td>
        <td className="text-left text-truncate">{item.behaviorRate}</td>

        <td className="text-center">
          <button
            className="btn btn-primary"
            onClick={() => {
              handleViewDetails(item);
            }}
          >
            View
          </button>
        </td>
      </tr>
      {showGroupDialog && (
        <ViewGroupDialog
          enableToDelete={false}
          group={item}
          showGroupDialog={showGroupDialog}
          setShowGroupDialog={setShowGroupDialog}
        />
      )}

      {isDetailsOpen && (
        <VoteDetailsDialog
          open={isDetailsOpen}
          onClose={handleCloseDetails}
          voteData={selectedVote}
        />
      )}
    </>
  );
};
export default GroupScoreCard;
